import React, { useEffect, useState } from 'react'

import { Link as RouterLink } from 'react-router-dom'

import {
  IconButton,
} from '@mui/material'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import { DataGrid, esES } from '@mui/x-data-grid'

const AssignedStudentsTable = (props) => {
  const { rows, onStudentsSelected, selectedStudents } = props

  const columns = [
    // { field: 'id', headerName: 'ID', width: 70 },
    { 
      field: 'name', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Nombre'}</b>
      ),
      renderCell: (params) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <b>{params.value}</b>
        </span>
      ),
      minWidth: 220,
      flex: 2,
      hideable: false,
    },
    { 
      field: 'email', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Email'}</b>
      ), 
      minWidth: 220,
      flex: 2,
    },
    { 
      field: 'id',
      headerName: '',
      flex: 0,
      renderCell: (params) => (
        <IconButton component={RouterLink} to={`/director/alumnos/${params.value}`}>
          <ChevronRightIcon />
        </IconButton>
      ),
      type: 'singleSelect',
      align: 'right',
      sortable: false,
      filterable: false,
      hideable: false,
    },
  ]

  const [selectionModel, setSelectionModel] = useState(selectedStudents)
  const onSelectionModelChange = (model) => {
    onStudentsSelected(model)
    setSelectionModel(model)
  }

  useEffect(() => {
    setSelectionModel(selectedStudents)
  }, [selectedStudents])

  return (
    <DataGrid
      autoHeight
      checkboxSelection
      disableSelectionOnClick
      columns={columns}
      localeText={esES.components.MuiDataGrid.defaultProps.localeText}
      pageSize={10}
      rows={rows}
      rowsPerPageOptions={[10]}
      onSelectionModelChange={onSelectionModelChange}
      selectionModel={selectionModel}
      sx={{ borderWidth: 0 }}
    />
  )
}

export default AssignedStudentsTable